document.addEventListener('change', function (event) {
  const target = event.target;

  // Verifica se l'elemento modificato è un charm normale
  const isCharmCheckbox =
    target.matches('input.opfr-checkbox[type="checkbox"]') &&
    (target.name || '').includes('Scegli i tuoi charms');

  // Verifica se l'elemento modificato è uno dei menu LETTERA
  const isLetterSelect =
    target.matches('select[name*="LETTERA"]');

  // Ignora tutto il resto della pagina
  if (!isCharmCheckbox && !isLetterSelect) return;

  // Tutti i charm normali
  const charmCheckboxes = Array.from(
    document.querySelectorAll('input.opfr-checkbox[type="checkbox"]')
  ).filter(function (checkbox) {
    return (checkbox.name || '').includes('Scegli i tuoi charms');
  });

  // Tutti i menu delle lettere
  const letterSelects = Array.from(
    document.querySelectorAll('select[name*="LETTERA"]')
  );

  // Conta i charm normali selezionati
  const selectedCharms = charmCheckboxes.filter(function (checkbox) {
    return checkbox.checked;
  }).length;

  // Conta le lettere selezionate
  const selectedLetters = letterSelects.filter(function (select) {
    return select.value && select.value.trim() !== '';
  }).length;

  const totalSelected = selectedCharms + selectedLetters;

  // Finché siamo a massimo 3, va tutto bene
  if (totalSelected <= 3) return;

  // Se il quarto elemento è un charm normale:
  // lo deseleziona e comunica la modifica a Optionfier
  if (isCharmCheckbox && target.checked) {
    target.checked = false;

    setTimeout(function () {
      target.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }, 0);

    alert('Puoi scegliere un massimo di 3 charms in totale, comprese le lettere.');
    return;
  }

  // Se il quarto elemento è una lettera:
  // la riporta a "nessuna selezione"
  if (isLetterSelect && target.value) {
    target.value = '';

    setTimeout(function () {
      target.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }, 0);

    alert('Puoi scegliere un massimo di 3 charms in totale, comprese le lettere.');
  }
});